import React from 'react';
import '../../styles/onboardingFlow/onboardingComponents/onboardingBackButton.scss';
import ArrowCircleLeft from '../../assets/onboarding/common/ArrowCircleLeft.svg';

type Props = {
  onClick: () => void;
  'aria-label'?: string;
};

const OnboardingBackButton: React.FC<Props> = ({
  onClick,
  'aria-label': ariaLabel = 'Go back',
}) => {
  return (
    <button
      type='button'
      className='onboardingBackButton'
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <img src={ArrowCircleLeft} alt='' className='onboardingBackButton__icon' />
    </button>
  );
};

export default OnboardingBackButton;
